import React, { useState } from "react";
import Uploaded from "../components/fileUploaded/Uploaded";
import Uploading from "../components/fileUploading/Uploading";

import "./upload.css";

export default function Upload({ change1 }) {
  const [fileLoaded, setFileLoaded] = useState("");
  const [fileTotal, setFileTotal] = useState("");
  const [fileSize, setFileSize] = useState("");
  const [progress, setProgress] = useState("");
  const [file, setFile] = useState("");
  const [fileName, setFileName] = useState("");

  const UploadFile = (fileData) => {
    let xhr = new XMLHttpRequest();
    xhr.open("POST", "http://64.227.154.216:3001/api/v1/queryOrReply/upload");

    xhr.upload.addEventListener("progress", ({ loaded, total }) => {
      setFileLoaded(Math.floor((loaded / total) * 100));
      setFileTotal(Math.floor(total / 1000));
      fileTotal < 1024
        ? setFileSize(fileTotal + " KB")
        : setFileSize((loaded / (1024 * 1024)).toFixed(2) + " MB");
      setProgress("true");

      if (loaded === total) {
        setProgress("false");
      }
    });

    xhr.send(fileData);
  };

  const handleFile = () => {
    if (file) {
      setFileName(file.name);
      if (fileName.length >= 12) {
        let splitName = fileName.split(".");
        setFileName(splitName[0].substring(0, 13) + "... ." + splitName[1]);
      }

      const formData = new FormData();
      formData.append("name", file.name);
      formData.append("uploadfile", file);
      UploadFile(formData);
    }
    setFile("");
  };
  if (file) {
    handleFile();
  }

  return (
    <div className="all_upload_container">
      <div className="wrapper">
        <h6 className="uploadHeading">Upload File</h6>
        <form>
          <input
            className="file-input"
            type="file"
            accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
            name="file"
            onChange={(e) => setFile(e.target.files[0])}
            id="getFile"
            hidden
          />
          <label htmlFor="getFile">
            <p className="uploadBtn_files">Select File</p>
            <p className="dropDragTxt">drag & drop here</p>
          </label>
        </form>
        <section className="progress-area">
          {progress === "true" && (
            <Uploading name={fileName} fileLoaded={fileLoaded} />
          )}
        </section>
        <section className="uploaded-area">
          {progress === "false" && <Uploaded name={fileName} fileSize={fileSize} />}
        </section>
      </div>
      <div>
        <img
          src="/group-img/CrossIconGroup.svg"
          className="cross_icon"
          alt="cros icon"
          onClick={(e) => change1(false)}
        />
      </div>
    </div>
  );
}
